import { render, staticRenderFns } from "./integralRuleDiv.vue?vue&type=template&id=d064a8f2&scoped=true"
import script from "./integralRuleDiv.vue?vue&type=script&lang=js"
export * from "./integralRuleDiv.vue?vue&type=script&lang=js"
import style0 from "./integralRuleDiv.vue?vue&type=style&index=0&id=d064a8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d064a8f2",
  null
  
)

export default component.exports